<template>
  <section id="card-text-alignment">
    <b-card title="Filtros">
      <b-row class="filters-row">
        <b-col cols="2">
          <b-form-group
              label="NÚMERO NF:"
              label-for="numero-nf"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon=""/>
              </b-input-group-prepend>
              <b-form-input
                  id="numero-nf"
                  type="text"
                  v-model="numero_nf"
                  placeholder="Número NF"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
              label="SITUAÇÃO:"
              label-for="situacao"
          >

            <b-form-select
                id="situacao"
                v-model="selected"
                :options="options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
              label="DE:"
              label-for="de"
          >
            <b-form-datepicker
                id="datepicker-default-1"
                v-model="de"
                local="pt-BR"
                class="mb-2"
                today-variant="danger"
                placeholder="dd/mm/aaaa"
                hide-header
                dark
                date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                weekday-header-format="narrow"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
              label="ATÉ:"
              label-for="ate"
          >
            <b-form-datepicker
                id="datepicker-default-2"
                v-model="ate"
                local="pt-BR"
                class="mb-2"
                today-variant="danger"
                placeholder="dd/mm/aaaa"
                hide-header
                dark
                date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                weekday-header-format="narrow"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-button-group>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                @click="filters('filter')"
            >
              Filtrar
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="limpar()"
            >
              Limpar
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <br>
      <b-table
          :striped="true"
          :bordered="true"
          :hover="true"
          :responsive="true"
          table-variant="secondary"
          :fields="fields"
          :items="getBoletos"
          :busy="getIsLoading"
          small
          show-empty
          empty-text="Nenhum boleto encontrado"
      >
        <!-- A virtual column -->
        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #cell(tituloSituacao)="data">
          {{ formatarSituacao(data.value) }}
        </template>

        <template #cell(action)="data">
          <div
              class="d-flex"
              style="gap:5px"
          >
            <b-button
                variant="success"
                size="sm"
            >
              <feather-icon icon="FileTextIcon"/>
            </b-button>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col sm="5" md="4" class="my-1">
          <b-form-group
              label="paginação"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
          >
            <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
                @change="handlePerPageChange"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="7" md="6" class="my-1">
          <b-pagination
              v-model="currentPage"
              :total-rows="pagination.totalItems"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
              @change="handlePageChange"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import PTC_BoletosService from '@/services/PTC/PTC_Boletos.service';
import Ripple from 'vue-ripple-directive';

const PTC_BoletosClient = new PTC_BoletosService();

export default {
  components: {
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      notafiscalnumero: this.$route.params.notafiscalnumero || null,
      fields: [
        { key: 'clienteiderp', label: 'Cliente Erp' },
        { key: 'banco_nome', label: 'Banco' },
        { key: 'titulonumero', label: 'Número Título' },
        { key: 'titulodocumento', label: 'Documento' },
        { key: 'tituloparcela', label: 'Parcela' },
        { key: 'titulodtemissao', label: 'Data Emissão' },
        { key: 'titulovalororiginal', label: 'Valor Original' },
        { key: 'tituloDtVencimento', label: 'Data Vencimento' },
        { key: 'titulodtliquidacao', label: 'Data Liquidação' },
        { key: 'tituloSituacao', label: 'Situação' },
        { key: 'clienterazaosocial', label: 'Razão Social' },
        { key: 'action', label: 'Ações' },
      ],
      items: [],
      selected: this.$route.query.situacao || null,
      options: [
        { value: null, text: '--Selecionar--', disabled: true },
        { value: 'AVENCER', text: 'A Vencer' },
        { value: 'LIQUIDADO', text: 'Liquidado' },
        { value: 'LIQUIDADOPARCIAL', text: 'Liquidado Parcial' },
        { value: 'VENCIDO', text: 'Vencido' },
      ],
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      numero_nf: null,
      de: '',
      ate: '',
      currentFilters: null,
    };
  },

  methods: {
    formatarSituacao(situacao) {
      if (!situacao) return '';

      const situacaoMap = {
        AVENCER: 'A Vencer',
        LIQUIDADO: 'Liquidado',
        LIQUIDADOPARCIAL: 'Liquidado Parcial',
        VENCIDO: 'Vencido',
      };

      return situacaoMap[situacao] || situacao;
    },
    async AllBoletos() {
      await PTC_BoletosClient.retornaBoletos({
        page: this.currentPage,
        limit: this.perPage,
      });
    },

    async filters() {
      const query = {};

      if (this.selected !== null) {
        query.tituloSituacao = this.selected;
      }

      if (this.numero_nf !== null && this.numero_nf !== '') {
        query.notafiscalnumero = this.numero_nf;
      }

      if (this.de !== null && this.de !== '' && this.ate !== null && this.ate !== '') {
        query.tituloDtEmissaoDe = this.de;
        query.tituloDtEmissaoAte = this.ate;
      }

      query.page = 1;
      query.limit = this.perPage;

      this.currentFilters = query;

      await PTC_BoletosClient.retornaBoletos(query);
      this.currentPage = 1;
    },

    async limpar() {
      this.selected = null;
      this.numero_nf = null;
      this.notafiscalnumero = null;
      this.de = '';
      this.ate = '';
      this.currentPage = 1;
      this.currentFilters = null;

      this.$router.replace({ name: this.$route.name });

      await PTC_BoletosClient.retornaBoletos({
        page: 1,
        limit: this.perPage,
      });
    },

    async handlePageChange(page) {
      const query = this.currentFilters || {};
      query.page = page;
      query.limit = this.perPage;

      await PTC_BoletosClient.retornaBoletos(query);
      console.log('Boletos após mudança de página:', this.getBoletos);
    },

    async handlePerPageChange(perPage) {
      const query = this.currentFilters || {};
      query.page = 1;
      query.limit = perPage;

      this.currentPage = 1;
      await PTC_BoletosClient.retornaBoletos(query);
    },
  },

  async mounted() {
    if (this.$route.query.situacao) {
      await this.filters();
    } else if (this.notafiscalnumero !== null) {
      this.numero_nf = this.notafiscalnumero;
      const query = {
        notafiscalnumero: this.notafiscalnumero,
        page: 1,
        limit: this.perPage,
      };
      this.currentFilters = query;
      await PTC_BoletosClient.retornaBoletos(query);
    } else {
      await this.AllBoletos();
    }
  },

  computed: {
    ...mapGetters({
      getBoletos: 'PTC_BoletosClient/getBoletos',
      getIsLoading: 'PTC_BoletosClient/getIsLoading',
      pagination: 'PTC_BoletosClient/getPagination',
    }),
  },

  watch: {
    'pagination.currentPage': function (newVal) {
      this.currentPage = newVal;
    },
    'pagination.perPage': function (newVal) {
      this.perPage = newVal;
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log('teste-1', toParams, previousParams);
        console.log('teste-2', this.$route.params);
      },
    );

    this.$watch(
      () => this.$route.query,
      (newQuery) => {
        if (newQuery.situacao && newQuery.situacao !== this.selected) {
          this.selected = newQuery.situacao;
          this.filters();
        }
      },
    );
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 767.98px) {
  .filters-row > .col-2,
  .filters-row > .col-4 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 0.5rem;
  }

  .filters-row > .col-4:last-child,
  .filters-row > .col-2:last-child {
    margin-bottom: 0;
  }
}
</style>
